export default __webpack_public_path__ + "static/media/golf-field3.0d71ba76.jpg";